/* Suspense fallback for a route chunk that has not resolved yet.

   Shaped like the page that is coming rather than a generic block, and it
   holds off for 120ms before it appears. A chunk on a warm cache resolves in
   well under that, and a skeleton that flashes for 40 frames-worth of nothing
   is more distracting than the imperceptible gap it replaced. */

import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Skeleton } from '../ui/Skeleton'

export function PageSkeleton() {
  const { t } = useTranslation()
  const [show, setShow] = useState(false)

  useEffect(() => {
    const id = window.setTimeout(() => setShow(true), 120)
    return () => window.clearTimeout(id)
  }, [])

  if (!show) return null

  return (
    <div className="shell page-skeleton" role="status" aria-busy="true">
      <span className="sr-only">{t('common.loading')}</span>
      <Skeleton w="45%" h={26} r="var(--r-sm)" />
      <div className="page-skeleton-grid" aria-hidden>
        {Array.from({ length: 6 }, (_, i) => (
          <Skeleton key={i} h={84} r="var(--r)" />
        ))}
      </div>
      <Skeleton w="35%" h={20} r="var(--r-sm)" />
      <div className="page-skeleton-rows" aria-hidden>
        {Array.from({ length: 3 }, (_, i) => (
          <Skeleton key={i} h={104} r="var(--r-xl)" />
        ))}
      </div>
    </div>
  )
}
